import { localStorageProxy } from '@breville/xps-utils/core-ts/localStorageProxy';

/**
 * Checks if Auth0 has cached tokens in localStorage.
 * Auth0 SPA SDK stores tokens under keys prefixed with '@@auth0spajs@@'.
 */
const validateAuthStorage = (): boolean => {
  if (typeof window === 'undefined') return false;

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith('@@auth0spajs@@')) {
      const value = localStorageProxy.getItem(key);
      if (value !== null) {
        return true;
      }
    }
  }

  return false;
};

export default validateAuthStorage;
